import { render, staticRenderFns } from "./RecipeImagePlaceholder.vue?vue&type=template&id=0b0394ce&"
import script from "./RecipeImagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./RecipeImagePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports